<template>
  <div>
    <Chart :options="chartOptions"></Chart>
  </div>
</template>

<script>
import { Chart } from "highcharts-vue";
import { toRefs } from "vue";
import Highcharts from "highcharts";
import more from "highcharts/highcharts-more";
more(Highcharts);

export default {
  components: { Chart },
  props: {
    labels: {
      type: Array,
      default: () => [],
    },
    series: {
      type: Array,
      default: () => [],
    },
    yAxisRange: {
      type: Array,
      default: () => [],
    },
    yAxisMin: {
      type: Number,
      default: 0,
    },
    yAxisMax: {
      type: Number,
      default: 5,
    },
    titleText: {
      type: String,
      default: "",
    },
    colors: {
      type: Array,
      default: () => ["#FED59E", "#80E4BA"],
    },
  },
  setup(props) {
    // generate props data
    const {
      labels,
      series,
      yAxisRange,
      titleText,
      colors,
      yAxisMin,
      yAxisMax,
    } = toRefs(props);

    const chartOptions = {
      chart: {
        style: {
          fontFamily: "iranyekan",
        },
        polar: true,
      },
      colors: colors.value,
      title: {
        text: titleText.value,
        align: "right",
      },
      subtitle: {
        text: "",
      },
      pane: {
        startAngle: 0,
        endAngle: 360,
      },
      legend: {
        rtl: true,
      },
      xAxis: {
        tickInterval: 1,
        min: 0,
        labels: {
          format: "",
        },
        categories: labels.value,
      },
      yAxis: {
        min: yAxisMin.value,
        max: yAxisMax.value,
        categories: yAxisRange.value,
      },
      plotOptions: {
        series: {
          pointStart: 0,
          pointInterval: 1,
        },
      },
      series: series.value,
    };
    // return data to be used in template
    return { chartOptions };
  },
};
</script>

<style lang="scss" scoped>
.highcharts-credits {
  display: none !important;
}
</style>
